import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Box,
  Stack,
  Breadcrumbs,
  Typography,
} from '@mui/material';
import { Button } from '../../../../../ui';
import { AssessmentContext } from '../../../../../utils/contexts/contexts';
import { RootState } from '../../../../../utils/redux_store/store';
import { SelectOptions } from '../../../../../utils/types/react_select_types';
import { Questions } from '../../../view/view_assessment/Questions';

export const CreateQuestions: React.FC = () => {
  const { assessmentState, setAssessmentState } = useContext(AssessmentContext);
  const skills = useSelector((state: RootState) => state.skills);
  const levels = useSelector((state: RootState) => state.skillLevels);
  const jobTitles = useSelector((state: RootState) => state.jobTitles);
  const subSkills = useSelector((state: RootState) => state.subSkills);
  const [skillList, setSkillList] = useState<SelectOptions[]>(
    skills.skillsList,
  );

  useEffect(() => {
    setSkillList(skills.skillsList);
  }, [skills.skillsList]);

  const navigateBackToBasicInfo = () => {
    setAssessmentState({
      ...assessmentState,
      assessmentPageNo: 1,
    });
  };

  const navigateToNextPage = () => {
    setAssessmentState({
      ...assessmentState,
      assessmentPageNo: 3,
    });
  };

  return (
    <Stack spacing={3} sx={{ width: '100%', height: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', pb: 1.5 }}>
        <Breadcrumbs aria-label='breadcrumb'>
          <Typography
            component={Link}
            to='#'
            variant='body2'
            color='text.secondary'
            sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            Create Assessment
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            Questions
          </Typography>
        </Breadcrumbs>
      </Box>

      <Typography variant='body2' color='text.secondary'>
        You can set up questions for assessment by searching questions from existing
        question bank / by creating new ones / by uploading a file and
        generating questions.
      </Typography>

      <Box>
        <Questions
          assessmentId={assessmentState.assessmentId}
          skillList={skillList}
          levelList={levels.levelList}
          jobTitleList={jobTitles.jobTitlesList}
          subSkillList={subSkills.subSkillsList}
          setSkillList={setSkillList}
        />
        <Stack
          direction='row'
          justifyContent='flex-end'
          spacing={2}
          sx={{ pt: 2, mt: 3, borderTop: 1, borderColor: 'divider' }}
        >
          <Button
            onClick={navigateBackToBasicInfo}
            variant='secondary'
            label='Back'
          />
          <Button onClick={navigateToNextPage} variant='primary' label='Next' />
        </Stack>
      </Box>
    </Stack>
  );
};
